import {
  CreateClusterRoleSuccessAction,
  UpdateClusterRoleSuccessAction
} from './clusterRoles.types';

export const createClusterRoleSuccess = (data: ClusterRole): CreateClusterRoleSuccessAction => ({
  type: 'CREATE_CLUSTER_ROLE_SUCCESS',
  payload: data
});

export const updateClusterRoleSuccess = (data: ClusterRole): UpdateClusterRoleSuccessAction => ({
  type: 'UPDATE_CLUSTER_ROLE_SUCCESS',
  payload: data
});
